import { render, staticRenderFns } from "./EditSettingTax.vue?vue&type=template&id=1b62f5c8"
import script from "./EditSettingTax.vue?vue&type=script&lang=js"
export * from "./EditSettingTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports